module.exports = __webpack_public_path__ + "static/media/LiveSentiment.cc97afa7.png";